import React from 'react';
function RemoveComponent(params) {
    return (
        <div className="test_button"><i className="fas fa-trash"></i> Remove</div>
    );
  }
const config = [
    {
        field: 'supplierName',
        headerName: 'Name',
        rowGroup: true,
        hide: true,
    },
    {
        colId: 'name',
        headerName: 'Name',
        field: 'name',
        floatingFilter: true,
        filter: 'agSetColumnFilter',
        suppressMovable: true,
        suppressHeaderMenuButton: true,
        icons: {
            sortAscending: '<i class="fas fa-caret-up"></i>',
            sortDescending: '<i class="fas fa-caret-down"></i>'
        }
    },
    {
        colId: 'email',
        headerName: 'E-Mail',
        field: 'email',
        floatingFilter: true,
        filter: 'agSetColumnFilter',
        suppressMovable: true,
        suppressHeaderMenuButton: true,
        icons: {
            sortAscending: '<i class="fas fa-caret-up"></i>',
            sortDescending: '<i class="fas fa-caret-down"></i>'
        }
    },
    {
        headerName: "Actions",
        field: "action",
        colId: "action",
        pinned: 'right',
        suppressSizeToFit: true,
        width: 100,
        suppressColumnsToolPanel: true,
        suppressHeaderMenuButton: true,
        tooltipField: 'reviewAction',
        suppressMovable: true,
        cellRenderer: params => {
            if (params.data && params.data.userId) {
                return <RemoveComponent />;
            }

        }
    },
];
export const autoGroupColumnDefForList =
{
    headerName: 'Group',
    filterValueGetter: params => [params.data?.supplierName, params.data?.name].filter(Boolean).join(' '), // Enables filtering by 'supplierName' and 'name'
    minWidth: 200,
    cellRenderer: 'agGroupCellRenderer',
    cellRendererParams: { checkbox: false },
    width: 500,
    suppressHeaderMenuButton: true,
    suppressMovable: true,
    floatingFilter: true,
    filter: 'agTextColumnFilter',
    icons: {
            sortAscending: '<i class="fas fa-caret-up"></i>',
            sortDescending: '<i class="fas fa-caret-down"></i>'
        },
}
export default config;
